import { render, staticRenderFns } from "./OrganizationCellRendererActions.vue?vue&type=template&id=24aab88e"
import script from "./OrganizationCellRendererActions.vue?vue&type=script&lang=js"
export * from "./OrganizationCellRendererActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports